import request from "@/utils/request";

export const review = {
  list: (params) =>
    request({
      url: "/api/backend/evaluation/product/list",
      method: "GET",
      params,
    }),
  merchant: (params) =>
    request({
      url: "/api/backend/evaluation/store/list",
      method: "GET",
      params,
    }),
  classify: (type) =>
    request({
      url: "/api/backend/evaluation/class/list",
      method: "GET",
      params: {
        type,
      },
    }),
  create: (form) =>
    request({
      url: "/api/backend/evaluation/product/add",
      method: "POST",
      data: { ...form },
    }),
  changeState: (id) =>
    request({
      url: "/api/backend/evaluation/product/state",
      method: "POST",
      data: { id },
    }),
  setRecommendation: (id) =>
    request({
      url: "/api/backend/evaluation/product/recommend",
      method: "POST",
      data: { id },
    }),
  platformList: () =>
    request({
      url: "/api/backend/evaluation/channel/list",
      method: "GET",
    }),
  questionnaireList: (params) =>
    request({
      url: "/api/backend/questionnaire/list",
      method: "GET",
      params
    }),
  delEvent: (id) =>
    request({
      url: "/api/backend/evaluation/product/del",
      method: "POST",
      data: { id },
    }),
  updateResidue: (data) =>
    request({
      url: "/api/backend/evaluation/product/updateResidue",
      method: "POST",
      data,
    }),
  endActive: (data) =>
    request({
      url: "/api/backend/evaluation/product/all/end",
      method: "POST",
      data,
    }),
  exportReviewExcel: (params) =>
      request({
        url: "/api/backend/excel/evaluation",
        method: "GET",
        params,
      }),
  exportQuestionExcel: (params) =>
      request({
        url: "/api/backend/excel/questionnaires",
        method: "GET",
        params,
        timeout: 6000000,
      }),
};
